import { clearUserInfo, setLoggedIn } from '@/lib/redux/actions/userActions';
import configureStore from '@/lib/redux/configureStore';

const BASE_URL = process.env.API_URL;
const store = configureStore();

const postRequest = async (input, endpoint) => {
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(input),
  };

  const response = await fetch(BASE_URL + endpoint, options);
  const json = await response.json();
  if (!response.ok) {
    throw json;
  }

  return json;
};

export const signup = async (input) => postRequest(input, '/signup');
// export const login =
// async (input) => postRequest(input, '/login'); // Accepts input of {email, password}
export const loginWithGoogle = async ({ token }) => postRequest({ token }, '/oauth/google');
export const requestNewMatch = async (user) => postRequest(user, '/newmatch');
export const verify = async (input) => postRequest(input, '/verify');
export const sendResetLink = async (input) => postRequest(input, '/password/lost');
export const resetPassword = async (input) => postRequest(input, '/password/change');
export const logMatchData = async (input) => postRequest(input, '/user/logmatchdata');
export const toggleConfirmStatus = async (input) => postRequest(input, '/toggleconfirm');
export const profileCompletion = async (input) => postRequest(input, '/profilecompletion');

// Fetch updated user data for a logged-in user
export const fetchUserInfo = async (user) => {
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(user),
  };

  const response = await fetch(`${BASE_URL}/userinfo`, options);
  const userData = await response.json();
  if (!response.ok) {
    throw userData;
  }

  let trainingCompleted = await fetch(`https://hn24sf2rnb.execute-api.us-east-1.amazonaws.com/default/make-matches-prod-trainingcomplete?email=${encodeURIComponent(user.email)}`, {
    method: 'GET',
  });
  const json = await trainingCompleted.json();
  if (!response.ok) {
    trainingCompleted = true;
  }

  // Should be either true or false, but could be an error message
  if (json.trainingCompleted === true) {
    // The user has already completed training or is in the existing user base
    trainingCompleted = true;
  } else if (json.trainingCompleted === false) {
    // The user has not completed training
    trainingCompleted = false;
  } else if (json.message === 'User not found') {
    // User is only in the older database
    trainingCompleted = true;
  }

  userData.trainingCompleted = trainingCompleted;

  return userData;
};

export const logout = () => {
  store.dispatch(clearUserInfo());
  store.dispatch(setLoggedIn(false));
  window.location.replace('/');
};
